<template>
  <main id="js-page-content" role="main" class="page-content">
    <div class="row">
      <div class="subheader col-6">
        <h1 class="subheader-title">
          請求書作成（売上なし）
          <sup
            v-if="delegate.c_claim_status == 0"
            class="badge badge-primary fw-500"
          >
            請求データ登録済</sup
          >
          <sup
            v-if="delegate.c_claim_status == 1"
            class="badge badge-warning fw-500"
          >
            承認待ち</sup
          >
          <sup
            v-if="delegate.c_claim_status == 3"
            class="badge badge-danger fw-500"
            >差し戻し</sup
          >
          <sup
            v-if="delegate.c_claim_status == 10"
            class="badge badge-info fw-500"
            >承認済・出力待ち</sup
          >
          <sup
            v-if="delegate.c_claim_status == 20"
            class="badge badge-success fw-500"
            >請求書作成済</sup
          >
        </h1>
      </div>
      <!-- Right content on content header A nice area to add graphs or buttons -->
      <div class="subheader-block ml-auto demo">
        <!-- <button
          type="button"
          class="btn btn-info waves-effect waves-themed"
          :disabled="btnDisable || btnDisable4conf"
          v-if="btnShow4conf"
        >
          <span class="fal fa-envelope mr-1"></span>コピー
        </button> -->

        <button
          type="button"
          class="btn btn-info waves-effect waves-themed"
          :disabled="btnDisable || btnDisable4Rewrite"
          v-if="btnShow4Rewrite && delegate.c_claim_status != null"
          @click="reriteConf()"
        >
          <span class="fal fa-undo-alt mr-1"></span>再編集
        </button>
        <button
          type="button"
          class="btn btn-primary waves-effect waves-themed"
          :disabled="btnDisable || btnDisable4conf"
          v-if="btnShow4conf && isEditMode"
          @click="upd(false, true, false)"
        >
          <span class="fal fa-envelope mr-1"></span>承認依頼
        </button>
        <button
          type="button"
          class="btn btn-primary waves-effect waves-themed"
          :disabled="btnDisable || btnDisable4save"
          v-if="btnShow4save && isEditMode"
          @click="upd(false, false, false)"
        >
          <span class="fal fa-check mr-1"></span>登録
        </button>
        <button
          type="button"
          class="btn btn-primary waves-effect waves-themed"
          :disabled="btnDisable"
          v-if="!isEditMode"
          @click="add()"
        >
          <span class="fal fa-check mr-1"></span>請求データ追加
        </button>
        <!-- //------- -->
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-primary waves-effect waves-themed"
            :disabled="btnDisable || btnDisable4create"
            v-if="btnShow4create && delegate.c_claim_status != null"
            @click="showModalInvoice()"
          >
            <span class="fal fa-download mr-1"></span>作成
          </button>
        </div>
        <!-- //------- -->
        <button
          type="button"
          class="btn btn-secondary waves-effect waves-themed"
          :disabled="btnDisable || btnDisable4create"
          v-if="btnShow4create"
          @click="showModalRakurakuhistory()"
        >
          楽楽明細履歴
        </button>
        <button
          type="button"
          class="btn btn-danger waves-effect waves-themed"
          :disabled="btnDisable || btnDisable4delete"
          v-if="btnShow4delete && isEditMode"
          @click="delConf()"
        >
          <span class="fal fa-times mr-1"></span>削除
        </button>
        <button
          :disabled="btnDisable"
          type="button"
          class="btn btn-secondary waves-effect waves-themed"
          @click="$router.push('/invoiceSearch')"
        >
          <span class="fal fa-reply mr-1"></span>戻る
        </button>
      </div>
    </div>
    <!-- 承認依頼メッセージ -->
    <div class="alert alert-danger" v-if="fmShowConf">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i class="fal fa-info-circle"></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5">あなたが承認者です</span>
            <p>
              この請求書はあなたが承認者です。以下のボタンから承認か、差戻を選択できます。
            </p>
            <p class="m-0">
              <button
                type="button"
                class="btn btn-info waves-effect waves-themed"
                @click="upd4Approval(true)"
              >
                <span class="fal fa-check mr-1"></span>承認
              </button>
              <span style="width: 20px"> 　</span>
              <button
                type="button"
                class="btn btn-danger waves-effect waves-themed"
                @click="upd4Approval(false)"
              >
                <span class="fal fa-times mr-1"></span>差戻
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 承認依頼メッセージ -->
    <!-- 承認依頼メッセージ 自己承認用 -->
    <div class="alert alert-primary" v-if="fmShowConf4self">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i class="fal fa-info-circle"></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5"
              >請求書を出力するには、ご自身での承認が必要です</span
            >
            <p>
              請求書を作り終わりましたら、以下の承認ボタンを押して、ご自身での承認をお願い致します。承認する事でExcel出力ができるようになります。
            </p>
            <p class="m-0">
              <button
                type="button"
                class="btn btn-info waves-effect waves-themed"
                @click="upd4Approval(true)"
              >
                <span class="fal fa-check mr-1"></span>承認
              </button>
              <span style="width: 20px"> 　</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 承認依頼メッセージ 自己承認用-->
    <!-- 承認処理待ちメッセージ -->
    <div class="alert alert-danger" v-if="fmShowConfEx">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i class="fal fa-info-circle"></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5">この請求書は承認依頼中です</span>
            <p>
              この請求書は承認依頼中の為、変更ができません。お急ぎの場合は、承認者にご連絡ください。
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 承認処理待ちメッセージ -->

    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>基本情報</h2>

            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-editers">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>

            <div class="panel-content contents">
              <div class="row">
                <div class="col-md-1 contTitle">請求No</div>
                <div class="col-md-5 contCnt input-daterange input-group">
                  <!-- <input
                    type="text"
                    name="txtClaimNo"
                    class="form-control form-control-sm claimNo"
                    disabled
                    v-model="delegate.c_claim_number"
                  /> -->
                  ―
                </div>
                <div class="col-md-1 contTitle">請求日</div>
                <div class="col-md-5 contCnt disableWhite">
                  <!-- <input
                    type="date"
                    name="txtClaimDate"
                    class="form-control form-control-sm"
                    :disabled="inputDisable4conf"
                    v-model="claimDate"
                  /> -->

                  <Mt_dtp
                    :disabled="inputDisable4conf"
                    v-model:contdate="claimDate"
                    v-model:holidays="delegate4list"
                    class="notClear"
                  ></Mt_dtp>
                  <div
                    v-if="errors?.path === 'claimDate'"
                    class="error-message4vali"
                  >
                    {{ errors.message }}
                  </div>
                </div>
              </div>
              <!-------------------->

              <div class="row">
                <div class="col-md-1 contTitle">請求先</div>
                <div class="col-md-3 contCnt disableWhite">
                  <vSelect
                    :disabled="inputDisable4conf"
                    :options="delegate4list.items4Client"
                    v-model="delegate.c_client_id"
                    label="c_client_name"
                    :reduce="(label:any) => label.c_client_id"
                  ></vSelect>
                  <div
                    v-if="errors?.path === 'c_client_id'"
                    class="error-message4vali"
                  >
                    {{ errors.message }}
                  </div>
                </div>
                <div class="col-md-2 contCnt">
                  <input
                    type="text"
                    name="txtClaimNo"
                    class="form-control form-control-sm claimNo"
                    disabled
                    v-model="paySite"
                  />
                </div>
                <div class="col-md-1 contTitle">担当者</div>
                <div class="col-md-5 contCnt disableWhite">
                  <vSelect
                    :disabled="inputDisable4conf"
                    :options="getOpStaffs()"
                    v-model="delegate.c_staff_id"
                    label="c_staff_name"
                    :reduce="(label:any) => label.c_staff_id"
                  ></vSelect>
                  <div
                    v-if="errors?.path === 'c_staff_id'"
                    class="error-message4vali"
                  >
                    {{ errors.message }}
                  </div>
                </div>
              </div>
              <!-------------------->

              <div class="row">
                <div class="col-md-1 contTitle">入金予定日</div>
                <div class="col-md-5 contCnt disableWhite">
                  <!-- <input
                    type="date"
                    name="txtPaymentKigen"
                    class="form-control form-control-sm"
                    :disabled="inputDisable4conf"
                    v-model="payLimit"
                  /> -->

                  <Mt_dtp
                    v-model:contdate="payLimit"
                    v-model:holidays="delegate4list"
                    :disabled="inputDisable4conf"
                    class="notClear"
                  ></Mt_dtp>
                  <div
                    v-if="errors?.path === 'payLimit'"
                    class="error-message4vali"
                  >
                    {{ errors.message }}
                  </div>
                </div>
                <div class="col-md-1 contTitle">備考</div>
                <div class="col-md-5 contCnt disableWhite">
                  <input
                    type="text"
                    name="txtBiko"
                    class="form-control form-control-sm"
                    :disabled="inputDisable4conf"
                    v-model="delegate.c_claim_remarks"
                  />
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle"></div>
                <div class="col-md-5 contCnt"></div>
                <div class="col-md-1 contTitle">件名</div>
                <div class="col-md-5 contCnt disableWhite">
                  <input
                    type="text"
                    name="txtBiko"
                    class="form-control form-control-sm"
                    :disabled="inputDisable4conf"
                    v-model="delegate.c_claim_title_1"
                  />
                </div>
              </div>
              <!-------------------->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-------------------->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>請求内容</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-editers4det">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content contents">
              <Or_tableClaim
                ref="Or_tableClaim"
                v-model:items="delegate.details"
              ></Or_tableClaim>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 成功通知モーダル -->
    <Mo_modal_alert ref="Mo_modal_success" @modalclosed="get()">
      <template v-slot:title>
        <i class="fal fa-check-circle text-success mr-2"></i>
        <span class="text-success fw-500">{{ message4ModalSuccess }}</span>
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer"><br /></div>
      </template>
    </Mo_modal_alert>
    <!-- 成功通知モーダル -->
    <!-- 再編集確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_rewiteConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalRewriteConf }}
      </template>
      <template v-slot:body>
        未承認の状態に戻りますと、再度、承認を経なければ請求書を出力する事ができません。
      </template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="rewrite()"
            type="button"
            class="btn btn-danger shadow-0 bootbox-accept"
          >
            はい</button
          ><button
            @click="closeModal4RewriteConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            いいえ
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- 再編集確認モーダル -->
    <!-- 削除確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_deleteConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalDelConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="del()"
            type="button"
            class="btn btn-danger shadow-0 bootbox-accept"
          >
            はい</button
          ><button
            @click="closeModal4deleteConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            いいえ
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- 削除確認モーダル -->
    <!-- 請求書作成モーダル -->
    <Mo_modal_n ref="Mo_modal_invoiceCreate">
      <template v-slot:title>請求書作成</template>
      <template v-slot:body>
        <div>
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              id="ckExcelDL"
              class="custom-control-input"
              v-model="invoiceCreateInfo.isExcelDownload"
            />
            <label class="custom-control-label" for="ckExcelDL"
              >Excelファイルをダウンロード</label
            >
          </div>
          <div
            class="custom-control custom-radio custom-control-inline"
            style="padding-top: 10px; margin-left: 20px"
          >
            <input
              type="radio"
              class="custom-control-input"
              id="radioMarkY"
              name="radioMark"
              value="1"
              v-model="invoiceCreateInfo.isCompanySealOutput"
            />
            <label class="custom-control-label" for="radioMarkY"
              >社印あり</label
            >
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              class="custom-control-input"
              id="radioMarkN"
              name="radioMark"
              value="2"
              v-model="invoiceCreateInfo.isCompanySealOutput"
            />
            <label class="custom-control-label" for="radioMarkN"
              >社印なし</label
            >
          </div>
          <br />
          <div
            class="custom-control custom-radio custom-control-inline"
            style="padding-top: 10px; margin-left: 20px"
          >
            <input
              type="radio"
              class="custom-control-input"
              id="radioFormatY"
              name="radioFormat"
              value="1"
              v-model="invoiceCreateInfo.outputFormat"
            />
            <label class="custom-control-label" for="radioFormatY"
              >新形式　</label
            >
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              class="custom-control-input"
              id="radioFormatN"
              name="radioFormat"
              value="0"
              v-model="invoiceCreateInfo.outputFormat"
            />
            <label class="custom-control-label" for="radioFormatN"
              >旧形式</label
            >
          </div>
          <div class="custom-control custom-checkbox" style="padding-top: 10px">
            <input
              type="checkbox"
              id="ckPdfDL"
              class="custom-control-input"
              v-model="invoiceCreateInfo.isPDFDownload"
              :disabled="isNotPdfDownload"
            />
            <label class="custom-control-label" for="ckPdfDL"
              >PDFファイルをダウンロード</label
            >
            &nbsp;&nbsp;<span
              style="color: red; font-weight: bold"
              v-text="pdfDownloadErr"
            ></span>
          </div>
          <div class="custom-control custom-checkbox" style="padding-top: 10px">
            <input
              type="checkbox"
              id="ckRakuRakuUp"
              class="custom-control-input"
              v-model="invoiceCreateInfo.isRakurakuUpload"
              :disabled="isNotRakurakuSync"
            />
            <label class="custom-control-label" for="ckRakuRakuUp"
              >楽楽明細に連携</label
            >
            &nbsp;&nbsp;<span
              style="color: red; font-weight: bold"
              v-text="rakurakuSyncErr"
            ></span>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-secondary waves-effect waves-themed"
          data-dismiss="modal"
          @click="execModalInvoice()"
        >
          OK
        </button>
        <button
          type="button"
          class="btn btn-secondary waves-effect waves-themed"
          data-dismiss="modal"
          @click="closeModalInvoice()"
        >
          キャンセル
        </button>
      </template>
    </Mo_modal_n>
    <!-- 請求書作成モーダル -->
    <!-- 楽楽明細連携履歴モーダル -->
    <Mo_modal_right_l ref="Mo_modal_rakuraku">
      <template v-slot:title>
        <div id="header4Recept">楽楽明細連携履歴</div>
      </template>
      <template v-slot:body>
        <div id="body4Rakuraku" class="panel-container">
          <div class="loader">
            <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
          </div>
          <vue-good-table
            mode="remote"
            v-on:page-change="onPageChange"
            v-on:sort-change="onSortChange"
            :columns="columns"
            :rows="rakurakuhistory"
            :sort-options="{
              enabled: false,
            }"
            :pagination-options="{
              enabled: false,
            }"
            :totalRows="delegate.pager.maxcount"
          >
            <template #table-row="props">
              <div class="gtablecell">
                {{ props.formattedRow[props.column.field] }}
              </div>
            </template>
          </vue-good-table>
          <!-- good table end -->
        </div>
      </template>
      <template v-slot:footer>
        <div id="footer4Recept" class="modal-footer">
          <button
            :disabled="btnDisable"
            type="button"
            class="btn btn-secondary waves-effect waves-themed"
            @click="closeModalRakurakuhistory()"
          >
            <span class="fal fa-reply mr-1"></span>閉じる
          </button>
        </div>
      </template>
    </Mo_modal_right_l>
    <!-- 楽楽明細連携履歴モーダル -->
    <!-- エラー確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_errorConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalErrorConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="closeModal4ErrorConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            確認
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Prop, Options, Vue, Watch } from "vue-property-decorator";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "vue-good-table-next/dist/vue-good-table-next.css";
import { VueGoodTable } from "vue-good-table-next";

import {
  CONST_AUTHORITY_STAFF_HENSYUSYA,
  CONST_AUTHORITY_STAFF_KANRISYA,
  CONST_AUTHORITY_STAFF_KENGENSYA,
  CONST_AUTHORITY_STAFF_NYURYOKUSYA,
  CONST_AUTHORITY_STAFF_SYUKEISYA,
  CONST_CLAIMSTATUS_SAKUSEIZUMI,
  CONST_CLAIMSTATUS_SASIMODOSI,
  CONST_CLAIMSTATUS_SYOUNINZUMI,
  CONST_CLAIMSTATUS_TOUROKUZUMI,
  CONST_RAKURAKU_SYNC_STATUS_OK,
  CONST_RAKURAKU_SYNC_STATUS_PDFERR,
  CONST_RAKURAKU_SYNC_STATUS_CUSTOMERERR,
} from "furukawa-common/src/common/constant/Constants";
import Or_tableClaim from "@/components/organisms/Or_tableClaim.vue";
import { EntityClaimRakurakuHistoryImple } from "furukawa-common/src/common/entity/EntityClaimRakurakuHistoryImple";
import { Cl_common } from "@/functions/Cl_common";
import { Cl_filemaster } from "@/functions/Cl_filemaster";

import { Cl_claim } from "@/functions/Cl_claim";
import { DtoClaimsGetReqImple } from "furukawa-common/src/common/dto/DtoClaimsGetReqImple";
import { DtoClaimsGetResImple } from "furukawa-common/src/common/dto/DtoClaimsGetResImple";
import { DtoClaimsPostReqImple } from "furukawa-common/src/common/dto/DtoClaimsPostReqImple";
import { DtoClaimsPostResImple } from "furukawa-common/src/common/dto/DtoClaimsPostResImple";
import { Cl_master } from "@/functions/Cl_master";
import { DtoMastersgetReq } from "furukawa-common/src/common/dto/DtoMastersGetReq";
import { DtoMastersGetRes } from "furukawa-common/src/common/dto/DtoMastersGetRes";
import { DtoClaimsPutReq } from "furukawa-common/src/common/dto/abst/DtoClaimsPutReq";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";
import { DtoFileMastersGetReqImple } from "furukawa-common/src/common/dto/DtoFileMastersGetReqImple";
import Mo_modal_n from "@/components/molecules/Mo_modal_n.vue";
import Mo_modal_right_l from "@/components/molecules/Mo_modal_right_l.vue";
import { Cl_docfile } from "@/functions/Cl_docfile";
import { Cl_docfileImple } from "@/functions/Cl_docfileImple";
import { Cl_claimrakurakuhistory } from "@/functions/Cl_claimrakurakuhistory";
import { DtoDocfilesGetReqImple } from "furukawa-common/src/common/dto/DtoDocfilesGetReqImple";
import { DtoDocfilesGetResImple } from "furukawa-common/src/common/dto/DtoDocfilesGetResImple";

//DTP
import Mt_dtp from "@/components/atoms/Mt_dtp.vue";
import { DtoMdDtp } from "furukawa-common/src/common/dto/DtoMdDtp";
import "@vuepic/vue-datepicker/dist/main.css";

// バリデーション
import * as Yup from "yup";
import { EntityStaff } from "../../../furukawa-common/src/common/entity/EntityStaff";
import { DtoClaimRakurakuHistorysGetReqImple } from "furukawa-common/src/common/dto/DtoClaimRakurakuHistorysGetReqImple";
import { AxiosError } from "axios";

@Options({
  components: {
    vSelect,
    VueGoodTable,
    Or_tableClaim,
    Mo_modal_alert,
    Mt_dtp,
    Mo_modal_n,
    Mo_modal_right_l,
  },
})
export default class InvoiceCreationFormNs extends Vue {
  //----------------------
  //バリデーション
  //----------------------
  //スキーマ宣言
  schema = Yup.object().shape({
    c_client_id: Yup.string().required("請求先を選択してください"),
    claimDate: Yup.string().required("請求日を設定してください"),
    c_staff_id: Yup.string().required("担当者を選択してください"),
    payLimit: Yup.string().required("入金予定日を設定してください"),
  });
  //エラー格納用
  errors: Yup.ValidationError | null = null;
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  delegate = new DtoClaimsGetResImple();
  delegate4list = new DtoMastersGetRes();
  claimDate: DtoMdDtp = new DtoMdDtp();
  payLimit: DtoMdDtp = new DtoMdDtp();
  btnDisable = false;
  claimNumber = "";
  paySite = "支払サイト：未設定";
  isEditMode = true;

  // 楽楽明細履歴一覧の項目
  columns = [
    {
      label: "日時",
      field: "date",
      dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXX",
      dateOutputFormat: "yyyy/MM/dd HH:mm:ss",
      type: "date",
      width: "160px",
      thClass: "text-left",
      tdClass: "text-left",
    },
    {
      label: "担当者",
      field: "staff",
      thClass: "text-left",
      tdClass: "text-left",
    },
    {
      label: "内容",
      field: "content",
      thClass: "text-left",
      tdClass: "text-left",
    },
  ];

  rakurakuhistory: { date: Date; content: string; staff: string }[] = [];

  // 楽楽明細に連携可能か
  isNotRakurakuSync = false;
  // 楽楽明細に連携不可能な時のエラーメッセージ
  rakurakuSyncErr = "";
  // PDFをダウンロード可能か
  isNotPdfDownload = false;
  // PDFダウンロード不可のエラーメッセージ
  pdfDownloadErr = "";
  // 請求書作成
  invoiceCreateInfo: {
    //形式 1:新 2:旧
    outputFormat: number;
    //Excelダウンロード
    isExcelDownload: boolean;
    //PDFダウンロード
    isPDFDownload: boolean;
    //楽楽明細連携
    isRakurakuUpload: boolean;
    //社印有無
    isCompanySealOutput: number;
  } = {
    outputFormat: 1,
    isExcelDownload: true,
    isPDFDownload: false,
    isRakurakuUpload: false,
    isCompanySealOutput: 1,
  };

  //NULL判定のCSSバインド用。
  isNull = false;
  //入力欄の有効無効フラグ
  inputDisable4conf = false;
  //各ボタン個別の有効無効フラグ
  btnDisable4conf = false;
  btnDisable4delete = false;
  btnDisable4save = false;
  btnDisable4create = false;
  btnDisable4Rewrite = false;
  //各ボタンの個別の表示非表示フラグ
  btnShow4conf = true;
  btnShow4delete = true;
  btnShow4save = true;
  btnShow4create = true;
  btnShow4Rewrite = true;
  //承認フォームの表示非表示フラグ
  fmShowConf = false;
  fmShowConf4self = false;
  fmShowConfEx = false;
  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  /**
   * 社員の選択肢を構築する用
   */
  getOpStaffs(): EntityStaff[] {
    return this.delegate4list.getStaffSortNum4NoneDelete([
      this.delegate.c_staff_id!,
    ]);
  }
  //----------------------
  //モーダル用プロパティ
  //----------------------
  message4ModalSuccess = "";
  message4ModalDelConf = "";
  message4ModalErrorConf = "";
  message4ModalRewriteConf = "";

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    await this.getMastersList();
    this.get();
  }
  /**
   * ボタンの表示制御
   */
  async adjButton() {
    //storeの値とLSの値を同期
    this.$store.commit("revStore");
    const detTable: any = this.$refs.Or_tableClaim;

    // ※読み込み失敗は全て無効化
    //-------------------------
    if (this.delegate.c_claim_id == null) {
      this.btnDisable4conf = true;
      this.btnDisable4delete = true;
      this.btnDisable4save = true;
      this.btnDisable4create = true;
      this.btnDisable4Rewrite = true;
      detTable.eventAdjButton(true);
      this.fmShowConf = false;
      this.fmShowConf4self = false;
      this.fmShowConfEx = false;
      this.fmShowConf4self = false;
      this.claimNumber = "";
      this.isNull = true;

      //新規登録モードなら明細有効化。
      if (!this.isEditMode) {
        detTable.eventAdjButton(false);
      }

      return;
    } else {
      this.btnDisable4conf = false;
      this.btnDisable4delete = false;
      this.btnDisable4save = false;
      this.btnDisable4create = false;
      this.btnDisable4Rewrite = false;
      detTable.eventAdjButton(false);
      this.isNull = false;
    }

    // 請求データ登録						ステータス 登録済み0 or 差戻済み3で表示
    //-------------------------
    if (
      this.delegate.c_claim_status == CONST_CLAIMSTATUS_TOUROKUZUMI ||
      this.delegate.c_claim_status == CONST_CLAIMSTATUS_SASIMODOSI
    ) {
      this.btnShow4save = true;
      this.btnDisable4save = false;
    } else {
      this.btnShow4save = false;
      this.btnDisable4save = true;
    }

    // 承認依頼						自身が請求承認必要＋ステータス0 or 3で表示、それ以外は非表示
    //-------------------------
    if (
      (this.$store.state.authType == CONST_AUTHORITY_STAFF_NYURYOKUSYA ||
        this.$store.state.authType == CONST_AUTHORITY_STAFF_SYUKEISYA ||
        this.$store.state.authType == CONST_AUTHORITY_STAFF_HENSYUSYA) &&
      (this.delegate.c_claim_status == 0 || this.delegate.c_claim_status == 3)
    ) {
      this.btnShow4conf = true;
      this.btnDisable4conf = false;
    } else {
      this.btnShow4conf = false;
      this.btnDisable4conf = true;
    }
    // 作成						ステータスが10 or 20で表示、それ以外は非表示
    //-------------------------
    if (
      this.delegate.c_claim_status == 10 ||
      this.delegate.c_claim_status == 20
    ) {
      this.btnShow4create = true;
      this.btnDisable4create = false;
    } else {
      this.btnShow4create = false;
      this.btnDisable4create = true;
    }

    // 再編集						ステータスが承認済・出力待ち(10) or 請求書作成済(20)、それ以外は非表示
    //-------------------------
    if (
      // this.$store.state.flagAuthClaim == 2 ||
      this.delegate.c_claim_status == CONST_CLAIMSTATUS_SYOUNINZUMI ||
      this.delegate.c_claim_status == CONST_CLAIMSTATUS_SAKUSEIZUMI
    ) {
      this.btnShow4Rewrite = true;
      this.btnDisable4Rewrite = false;
    } else {
      this.btnShow4Rewrite = false;
      this.btnDisable4Rewrite = true;
    }

    // 自己承認						ステータス請求データ登録済(0)もしくは差し戻し(3)、かつ自身が権限者or管理者の場合表示、それ以外は非表示
    //-------------------------
    if (
      (this.delegate.c_claim_status == CONST_CLAIMSTATUS_TOUROKUZUMI ||
        this.delegate.c_claim_status == CONST_CLAIMSTATUS_SASIMODOSI) &&
      (this.$store.state.authType == CONST_AUTHORITY_STAFF_KENGENSYA ||
        this.$store.state.authType == CONST_AUTHORITY_STAFF_KANRISYA)
    ) {
      this.fmShowConf4self = true;
    } else {
      this.fmShowConf4self = false;
    }

    // 承認					ステータスが1、かつ自身が承認者の場合表示、それ以外は非表示
    // 差戻					ステータスが1、かつ自身が承認者の場合表示、それ以外は非表示
    //-------------------------
    if (this.delegate.c_claim_status == 1) {
      if (this.delegate.elderStaffIds.indexOf(this.$store.state.id) != -1) {
        //承認依頼中で自身が承認者
        this.fmShowConf = true;
        this.btnDisable4conf = true;
        this.btnDisable4delete = true;
        this.btnDisable4save = true;
        this.btnDisable4create = true;
        detTable.eventAdjButton(true);
      } else {
        //承認依頼中で自身が承認者でない
        this.fmShowConfEx = true;
        this.btnDisable4conf = true;
        this.btnDisable4delete = true;
        this.btnDisable4save = true;
        this.btnDisable4create = true;
        detTable.eventAdjButton(true);
      }
    } else {
      this.fmShowConf = false;
      this.fmShowConfEx = false;
    }

    //入力用UI　　　　　　　ステータスが承認済・出力待ち(10) or 請求書作成済(20)で編集不可能、それ以外は編集可能。
    //-------------------------
    if (
      this.delegate.c_claim_status == CONST_CLAIMSTATUS_SYOUNINZUMI ||
      this.delegate.c_claim_status == CONST_CLAIMSTATUS_SAKUSEIZUMI
    ) {
      this.inputDisable4conf = true;
      detTable.eventAdjButton(true);
    } else {
      this.inputDisable4conf = false;
      detTable.eventAdjButton(false);
    }
  }
  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   *Masters取得用
   */
  async getMastersList() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });
    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行社員マスタ取得");
      //準備
      //-------
      let dtoMaster = new DtoMastersgetReq();
      dtoMaster.getStaff4sortNum = 1;
      dtoMaster.delFlag4Staff4sortNum = 0;
      // dtoMaster.getStaff = 1;
      // dtoMaster.delFlag4staff = 1;
      dtoMaster.getClients = 1;
      dtoMaster.delFlag4clients = 1;
      // dtoMaster.getBank = 1;
      // dtoMaster.delFlag4Bank = 1;

      //カレンダー休日反映用
      dtoMaster.getHoliday = 1;

      //API実行
      //-------
      this.delegate4list = await Cl_master.get(dtoMaster);
      //レスポンス処理
      //-------
      Cl_common.logger(this.delegate4list);
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
      this.delegate4list = new DtoMastersGetRes();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * データを読み込む
   */
  async get() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });
    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");
      //パラメータにIDが指定されていなければ、新規追加モードでデータを読み込まない
      //-------
      let id = Cl_common.getParam("claimnum");
      if (id == "") {
        //新規追加
        this.isEditMode = false;
        // const detTable: any = this.$refs.Or_tableClaim;
        // detTable.eventAdjButton(false);
        //初期値設定

        return;
      } else {
        this.isEditMode = true;
      }
      //準備
      //-------
      let dto = new DtoClaimsGetReqImple();
      dto.c_claim_id = Number(id); //APIのURL構成の関係で、請求書Noを請求書IDに入れているので注意
      dto.flagSales = 0;
      //API実行
      //-------
      this.delegate = await Cl_claim.get(dto);
      Cl_common.logger(this.delegate);
      if (this.delegate.c_claim_id == null) {
        this.$router.push("/invoiceSearch");
      }
      //日付展開
      if (this.delegate.c_claim_datetime != null) {
        this.claimDate.date = this.delegate.c_claim_datetime
          .toString()
          .split("T")[0];
      }
      if (this.delegate.c_claim_date_exp_payment != null) {
        this.payLimit.date = this.delegate.c_claim_date_exp_payment
          .toString()
          .split("T")[0];
      }

      //請求No展開
      this.claimNumber = this.delegate.c_claim_number!.toString();
      //明細の金額にカンマを付ける調整
      await this.cnvDetails();
      this.inputDisable4conf = false;
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
      Cl_common.logger(error);
      this.delegate = new DtoClaimsGetResImple();
      this.inputDisable4conf = true;
    } finally {
      //button調整
      await this.adjButton();
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * 明細内のデータを調整
   */
  async cnvDetails() {
    for (let i = 0; i < this.delegate.details.length; ++i) {
      //金額
      if (
        this.delegate.details[i].c_claim_det_price == null ||
        this.delegate.details[i].c_claim_det_price == ""
      ) {
        // this.delegate.details[i].c_claim_det_price = "0";
      } else {
        //カンマ補完
        while (
          this.delegate.details[i].c_claim_det_price !=
          (this.delegate.details[i].c_claim_det_price = this.delegate.details[
            i
          ].c_claim_det_price!.replace(/^(-?\d+)(\d{3})/, "$1,$2"))
        );
      }
    }

    for (let i = 0; i < this.delegate.details.length; ++i) {
      //金額
      if (
        this.delegate.details[i].c_claim_det_unitprice == null ||
        this.delegate.details[i].c_claim_det_unitprice == ""
      ) {
        // this.delegate.details[i].c_claim_det_price = "0";
      } else {
        //カンマ補完
        while (
          this.delegate.details[i].c_claim_det_unitprice !=
          (this.delegate.details[i].c_claim_det_unitprice =
            this.delegate.details[i].c_claim_det_unitprice!.replace(
              /^(-?\d+)(\d{3})/,
              "$1,$2"
            ))
        );
      }
    }
  }
  /**
   * データを更新する
   */
  async upd(isDel: boolean, isRequest: boolean, isNoModal: boolean) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    if (!isNoModal) {
      Array.from(panel).map((element: Element) => {
        element.classList.add("enable-loader");
      });
    }
    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoClaimsPutReq();
      if (isDel) {
        //削除処理：削除フラグを立てる。
        dto.c_claim_id = this.delegate.c_claim_id;
        dto.c_claim_flag_del = 1;
      } else {
        //バリデーション
        //-----------------
        this.errors = null;
        this.schema.validateSync({
          c_client_id: this.delegate.c_client_id,
          claimDate: this.claimDate.date,
          c_staff_id: this.delegate.c_staff_id,
          payLimit: this.payLimit.date,
        });

        //更新処理：delegateからdtoにデータ投入。
        dto = Object.assign(new DtoClaimsPutReq(), this.delegate);
        //日付をDTOに戻す
        if (this.claimDate.date != null && this.claimDate.date != "") {
          // console.log(this.claimDate);
          dto.c_claim_datetime = new Date(this.claimDate.date);
        }
        if (this.payLimit.date != null && this.payLimit.date != "") {
          dto.c_claim_date_exp_payment = new Date(this.payLimit.date);
        }
        //明細の合計を取得
        const tableClaim: any = this.$refs.Or_tableClaim;
        const sum = tableClaim.getSum();
        dto.c_claim_subtotal = sum[0].replaceAll(",", "");
        dto.c_claim_total = sum[1].replaceAll(",", "");
        if (isRequest) {
          //承認申請押下
          dto.c_claim_status = 1;
        }
      }
      //API実行
      //-------
      await Cl_claim.put(dto);
      //レスポンスの処理
      //-------
      //更新処理：
      //モーダルのメッセージを設定
      if (isDel) {
        //削除処理：
        this.message4ModalSuccess = "正常に削除されました";
      } else {
        //更新処理：
        this.message4ModalSuccess = "正常に変更されました";
      }
      //モーダルを表示
      if (!isNoModal) {
        const modal: any = this.$refs.Mo_modal_success;
        modal.showModal();
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      if (!isNoModal) {
        this.btnDisable = false;
        Array.from(panel).map((element: Element) => {
          element.classList.remove("enable-loader");
        });
      }
    }
  }
  /**
   * データを登録する
   */
  async add() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");

    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //バリデーション
      //-----------------
      this.errors = null;
      this.schema.validateSync({
        c_client_id: this.delegate.c_client_id,
        claimDate: this.claimDate.date,
        c_staff_id: this.delegate.c_staff_id,
        payLimit: this.payLimit.date,
      });

      //準備
      //-------
      let dto = new DtoClaimsPostReqImple();
      //登録処理：delegateからdtoにデータ投入。
      dto = Object.assign(new DtoClaimsPostReqImple(), this.delegate);
      dto.isNoSales = 1;
      //日付をDTOに戻す
      if (this.claimDate.date != null && this.claimDate.date != "") {
        // console.log(this.claimDate);
        dto.c_claim_datetime = new Date(this.claimDate.date);
      }
      if (this.payLimit.date != null && this.payLimit.date != "") {
        dto.c_claim_date_exp_payment = new Date(this.payLimit.date);
      }
      //明細の合計を取得
      const tableClaim: any = this.$refs.Or_tableClaim;
      const sum = tableClaim.getSum();
      dto.c_claim_subtotal = sum[0].replaceAll(",", "");
      dto.c_claim_total = sum[1].replaceAll(",", "");

      //API実行
      //-------
      const res = await Cl_claim.post(dto);
      //レスポンスの処理
      //-------
      //編集画面のURL作成
      this.$router.push({
        path: "/invoiceCreationFormNs",
        query: { claimnum: res.c_claim_number },
      });

      //モーダルのメッセージを設定

      //更新処理：
      this.message4ModalSuccess = "正常に追加されました";

      //モーダルを表示

      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------

      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * PDFのダウンロード
   */
  async expPdf() {
    try {
      //準備
      //-------
      let claimnum = Cl_common.getParam("claimnum");
      // 請求書IDをキーに文書ファイル情報を取得
      const resDoc = await Cl_docfileImple.getByClaimNumber(Number(claimnum));
      if (resDoc.items.length == 0) {
        //モーダルのメッセージを設定
        this.message4ModalErrorConf =
          "PDFファイルが見つかりませんでした(発行が完了していない可能性があります)";
        //モーダル表示
        const modal: any = this.$refs.Mo_modal_errorConf;
        modal.showModal();
        return;
      }

      //-------
      let dto = new DtoDocfilesGetReqImple();
      dto.c_docfile_id = resDoc.items[0].c_docfile_id;
      dto.c_doc_id = resDoc.items[0].c_doc_id;
      dto.c_staff_id = resDoc.items[0].c_staff_id;
      dto.c_docfile_ver = resDoc.items[0].c_docfile_ver;
      dto.c_docfile_imgpath = resDoc.items[0].c_docfile_imgpath;
      dto.c_docfile_filename = resDoc.items[0].c_docfile_filename;
      dto.c_docfile_filetype = resDoc.items[0].c_docfile_filetype;
      dto.c_docfile_size = resDoc.items[0].c_docfile_size;
      dto.c_docfile_dig = resDoc.items[0].c_docfile_dig;
      dto.c_docfile_ocrtxt = resDoc.items[0].c_docfile_ocrtxt;
      dto.c_docfile_flag_del = resDoc.items[0].c_docfile_flag_del;
      dto.c_docfile_reg_user = resDoc.items[0].c_docfile_reg_user;
      //API実行
      //-------
      const resPdf = await Cl_docfile.get(dto);
      Cl_common.logger(resPdf);
      Cl_common.logger(resPdf.url);
      //レスポンス処理
      //-------
      location.href = resPdf.url!;
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
      Cl_common.logger(error);
    }
  }
  /**
   * 請求書PDFを楽楽明細にアップロードする
   */
  async rakurakuUpload() {
    try {
      //準備
      //-------
      let claimnum = Cl_common.getParam("claimnum");
      // 請求書IDをキーに文書ファイル情報を取得
      const resDoc = await Cl_docfileImple.getByClaimNumber(Number(claimnum));
      if (resDoc.items.length == 0) {
        //モーダルのメッセージを設定
        this.message4ModalErrorConf =
          "PDFファイルが見つかりませんでした(発行が完了していない可能性があります)";
        //モーダル表示
        const modal: any = this.$refs.Mo_modal_errorConf;
        modal.showModal();
        return;
      }
      // 楽楽明細にPDFを連携するAPI実行
      const resDocSync = await Cl_docfileImple.syncRakuraku(Number(claimnum));
      // 連携成功後
      this.message4ModalSuccess = "楽楽明細に連携されました";
      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error: any) {
      if (error instanceof AxiosError) {
        let err = error as AxiosError;
        let data = JSON.parse(err.response?.data as string);
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = data.message;
        //モーダル表示
        const modal: any = this.$refs.Mo_modal_errorConf;
        modal.showModal();
        Cl_common.logger(error);
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
        //モーダル表示
        const modal: any = this.$refs.Mo_modal_errorConf;
        modal.showModal();
        Cl_common.logger(error);
      }
    }
  }
  /**
   * データを出力する
   */
  async exp(isSetStmp: boolean, isFormat_2025: boolean) {
    try {
      //バリデーション
      //-----------------
      this.errors = null;
      this.schema.validateSync({
        c_client_id: this.delegate.c_client_id,
        claimDate: this.claimDate.date,
        c_staff_id: this.delegate.c_staff_id,
        payLimit: this.payLimit.date,
      });
      //まず保存
      //-----------------
      await this.upd(false, false, true);
      //処理
      //-----------------
      Cl_common.logger("処理実行");
      //準備
      //-------
      let dto = new DtoFileMastersGetReqImple();
      dto.type = "claim";
      dto.claimNumber = this.delegate.c_claim_number;
      dto.claimId = this.delegate.c_claim_id;
      if (isSetStmp) {
        dto.isSetStmp = 1;
      }
      if (isFormat_2025) {
        dto.isFormat_2025 = 1;
      } else {
        dto.isFormat_2025 = 0;
      }

      // dto.deliverySlip = this.delegate.c_claim_flag_delivery;
      //API実行
      //-------
      const res = await Cl_filemaster.get(dto);
      Cl_common.logger(res);
      Cl_common.logger(res.url);
      //レスポンス処理
      //-------
      location.href = res.url;
      //レスポンスの処理
      //-------
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
      Cl_common.logger(error);
    }
  }
  /**
   * 楽楽明細連携履歴を取得
   */
  async getRakurakuHistory() {
    let claimnum = Cl_common.getParam("claimnum");
    let dto = new DtoClaimRakurakuHistorysGetReqImple();

    //検索条件設定
    dto.pager.count = 999999;
    dto.pager.cursor = 1;
    dto.c_claim_id = Number(claimnum);
    const res = await Cl_claimrakurakuhistory.getList(dto);
    let rakurakuhistorys: { date: Date; content: string; staff: string }[] = [];
    for (let index = 0; index < res.items.length; index++) {
      let item = res.items[index] as EntityClaimRakurakuHistoryImple;
      let dateItem = new Date();
      if (item.c_claim_rakuraku_history_reg_at) {
        dateItem = item.c_claim_rakuraku_history_reg_at;
      }
      let staffName: string;
      if (item.c_claim_rakuraku_history_reg_user_name) {
        staffName = item.c_claim_rakuraku_history_reg_user_name;
      } else {
        staffName = "";
      }
      let addItem: { date: Date; content: string; staff: string } = {
        date: dateItem,
        content: "楽楽明細に請求書を登録しました。",
        staff: staffName,
      };
      rakurakuhistorys.push(addItem);
    }
    this.rakurakuhistory = rakurakuhistorys;
  }
  /**
   * データを更新する
   * 承認・差戻用
   */
  async upd4Approval(isApproval: boolean) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });
    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //バリデーション
      //-----------------
      this.errors = null;
      this.schema.validateSync({
        c_client_id: this.delegate.c_client_id,
        claimDate: this.claimDate.date,
        c_staff_id: this.delegate.c_staff_id,
        payLimit: this.payLimit.date,
      });

      //一度保存
      await this.upd(false, false, true);

      //準備
      //-------
      let dto = new DtoClaimsPutReq();
      dto.c_claim_id = this.delegate.c_claim_id;
      dto.c_claim_flag_sales = this.delegate.c_claim_flag_sales;
      dto.c_claim_number = this.delegate.c_claim_number;
      dto.c_claim_title_1 = this.delegate.c_claim_title_1;
      dto.c_staff_id = this.delegate.c_staff_id;
      if (isApproval) {
        //承認
        dto.isApproval = 1;
      } else {
        //差戻
        dto.isApproval = 0;
      }
      //API実行
      //-------
      await Cl_claim.put(dto);
      //レスポンスの処理
      //-------
      //更新処理：
      //モーダルのメッセージを設定
      if (isApproval) {
        //削除処理：
        this.message4ModalSuccess = "正常に承認されました";
      } else {
        //更新処理：
        this.message4ModalSuccess = "正常に差戻されました";
      }
      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * データ削除用のモーダルを表示
   */
  async delConf() {
    //モーダルのメッセージを設定
    this.message4ModalDelConf =
      "請求No:" +
      this.delegate.c_claim_number +
      "　" +
      "を削除します。よろしいですか？";
    //モーダル表示
    const modal: any = this.$refs.Mo_modal_deleteConf;
    modal.showModal();
  }
  /**
   * データを削除する
   */
  async del() {
    //削除フラグのあるテーブルなので更新処理。
    this.closeModal4deleteConf();
    this.upd(true, false, false);
  }

  //-------------------
  /**
   * 再編集確認用のモーダルを表示
   */
  async reriteConf() {
    //モーダルのメッセージを設定
    this.message4ModalRewriteConf =
      "請求No:" +
      this.delegate.c_claim_number +
      "　" +
      "を再編集するために未承認の状態に戻します。よろしいですか？";
    //モーダル表示
    const modal: any = this.$refs.Mo_modal_rewiteConf;
    modal.showModal();
  }
  /**
   * 請求書を未承認状態に戻す
   */
  async rewrite() {
    this.closeModal4RewriteConf();

    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoClaimsPutReq();

      //削除処理：削除フラグを立てる。
      dto.c_claim_id = this.delegate.c_claim_id;
      dto.isRewite = 1;

      //API実行
      //-------
      await Cl_claim.put(dto);
      //レスポンスの処理
      //-------
      //モーダルのメッセージ
      this.message4ModalSuccess = "正常に変更されました";
      const modal: any = this.$refs.Mo_modal_success;

      modal.showModal();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------

      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  //-------------------

  /**
   * プロジェクトに遷移
   */
  async goProject() {
    if (this.delegate.project.c_project_number == null) {
      return;
    }
    await this.$router.push(
      "/projectInput:URL?record_id=" + this.delegate.project.c_project_number
    );
  }

  /**
   * 支払サイト表示更新
   */
  @Watch("delegate.c_client_id")
  getPaySite() {
    if (this.delegate.c_client_id == null) {
      this.paySite = "支払サイト：未設定";
    }

    let obj = this.delegate4list.items4Client.find(
      (item) => item.c_client_id === this.delegate.c_client_id
    );
    if (obj) {
      if (obj.c_client_paysite != null) {
        this.paySite = "支払サイト：" + obj.c_client_paysite;
      } else {
        this.paySite = "支払サイト：未設定";
      }
    } else {
      this.paySite = "支払サイト：未設定";
    }
  }

  // /**
  //  * 指定の請求Noへ遷移
  //  */
  // async goEnt() {
  //   await this.$router.push("/seikyusyocreate?claimnum=" + this.claimNumber);
  //   await this.get();
  // }
  // /**
  //  * 前の請求書に遷移
  //  */
  // async goPrev() {
  //   await this.$router.push(
  //     "/seikyusyocreate?claimnum=" + this.delegate.claimNumberPrev
  //   );
  //   await this.get();
  // }
  // /**
  //  * 次の請求書に遷移
  //  */
  // async goNext() {
  //   await this.$router.push(
  //     "/seikyusyocreate?claimnum=" + this.delegate.claimNumberNext
  //   );
  //   await this.get();
  // }
  /**
   * チェックボックスの値を数値に変換する
   * @param event
   */
  cnvCb(event: any): number {
    if (event.target.checked) {
      return 1;
    } else {
      return 0;
    }
  }
  //----------------------
  //モーダル用メソッド
  //----------------------
  async closeModal4RewriteConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_rewiteConf;
    modal.closeModal();
  }
  async closeModal4deleteConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_deleteConf;
    modal.closeModal();
  }
  async closeModal4ErrorConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_errorConf;
    modal.closeModal();
  }
  //モック時のコード
  //---------------------------
  /**
   * 請求書作成用モーダル表示
   */
  async showModalInvoice(): Promise<void> {
    this.isNotRakurakuSync = false;
    this.isNotPdfDownload = false;
    this.rakurakuSyncErr = "";
    this.pdfDownloadErr = "";

    //ボタン無効＋ローダー表示
    //-----------------
    if (this.btnDisable) {
      return;
    }
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });
    let res;
    try {
      //API実行
      //-------
      let claimnum = Cl_common.getParam("claimnum");
      res = await Cl_docfileImple.getSyncStatus(Number(claimnum));
      Cl_common.logger(res);
      if (res.status == CONST_RAKURAKU_SYNC_STATUS_PDFERR) {
        // 請求書PDF発行が完了していない(PDFダウンロード、楽楽明細連携の両方を不可にする)
        this.isNotRakurakuSync = true;
        this.isNotPdfDownload = true;
        this.rakurakuSyncErr = res.message!;
        this.pdfDownloadErr = res.message!;
      } else if (res.status == CONST_RAKURAKU_SYNC_STATUS_CUSTOMERERR) {
        // 請求先が楽楽明細側で「利用中」になっていない(楽楽明細連携を不可にする)
        this.isNotRakurakuSync = true;
        this.rakurakuSyncErr = res.message!;
      }
    } catch (error: any) {
      //それ以外
      //---------------
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
    const modalComp: any = this.$refs.Mo_modal_invoiceCreate;
    // 新形式／旧型式の設定(引数より)
    this.invoiceCreateInfo.outputFormat = 1;
    // 値のデフォルト設定(Excelファイルダウンロード)
    this.invoiceCreateInfo.isExcelDownload = true;
    // 値のデフォルト設定(PDFファイルダウンロード)
    this.invoiceCreateInfo.isPDFDownload = false;
    // 値のデフォルト設定(楽楽明細連携)
    this.invoiceCreateInfo.isRakurakuUpload = false;
    // 値のデフォルト設定(社印あり／なし)
    this.invoiceCreateInfo.isCompanySealOutput = 1;
    modalComp.showModal();
  }
  /**
   * 請求書作成用モーダルOK
   */
  async execModalInvoice(): Promise<void> {
    if (
      !this.invoiceCreateInfo.isExcelDownload &&
      !this.invoiceCreateInfo.isPDFDownload &&
      !this.invoiceCreateInfo.isRakurakuUpload
    ) {
      //チェックONのチェックボックスが一つもない場合はエラー
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "行う処理を選択してください";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
      return;
    }

    //ボタン無効＋ローダー表示
    //-----------------
    if (this.btnDisable) {
      return;
    }
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });
    try {
      //請求書作成POPUPを閉じる
      const modalComp: any = this.$refs.Mo_modal_invoiceCreate;
      modalComp.closeModal();
      if (this.invoiceCreateInfo.isExcelDownload) {
        // Excelファイルダウンロード実行
        await this.exp(
          this.invoiceCreateInfo.isCompanySealOutput == 1,
          this.invoiceCreateInfo.outputFormat == 1
        );
      }
      if (this.invoiceCreateInfo.isPDFDownload) {
        //PDFファイルダウンロード実行
        await this.expPdf();
      }
      if (this.invoiceCreateInfo.isRakurakuUpload) {
        //楽楽明細連携チェックONの場合
        await this.rakurakuUpload();
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
      Cl_common.logger(error);
    } finally {
      // //請求書作成POPUPを閉じる
      // const modalComp: any = this.$refs.Mo_modal_invoiceCreate;
      // modalComp.closeModal();
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * 請求書作成用モーダル閉じる
   */
  async closeModalInvoice(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_invoiceCreate;
    modalComp.closeModal();
  }
  /**
   * 楽楽明細連携履歴モーダル表示
   */
  async showModalRakurakuhistory(): Promise<void> {
    //ボタン無効＋ローダー表示
    //-----------------
    if (this.btnDisable) {
      return;
    }
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });
    try {
      // 楽楽明細履歴情報を取得
      await this.getRakurakuHistory();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }

    const modal: any = this.$refs.Mo_modal_rakuraku;
    modal.showModal();
  }
  /**
   * 楽楽明細連携履歴モーダル閉じる
   */
  async closeModalRakurakuhistory(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_rakuraku;
    modal.closeModal();
  }
  /**
   * ページ更新時の処理
   * @param params
   */
  async onPageChange(params: any) {
    //テーブル更新処理
    // await this.getlist(params.currentPage);
  }
  /**
   * ソート変更時の処理
   * @param params
   */
  async onSortChange(params: any) {
    //テーブル更新処理
  }
}
</script>
<style scoped>
.nullUi {
  border: 1px solid #f00;
}
.claimNo {
  background-color: #fff;
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
}

input:disabled:not([type="button"]),
textarea:disabled {
  background-color: #fff;
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
}

input[type="button"]:disabled {
  color: #444;
  background-color: #f4f4f4;
  border-color: #f4f4f4;
}
</style>
